import styled from "styled-components";

export const StyledCard = styled.div`
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid var(--PEARL, #ecf1f4);
  padding: 4px;

  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;

  &.master {
    align-items: center;
    color: #0e0e2c;
    display: flex;
    flex-shrink: 0;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    gap: 16px;
    line-height: 120%;
    padding: 16px;

    &:hover {
      box-shadow: 0 4px 8px rgba(0 0 0 / 0.12);
      transform: translateY(-1.5px);
      cursor: pointer;
    }
  }

  &.bulk {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px 24px;
  }

  &.bulk-progress-bar {
    align-items: center;
    box-shadow: 0 4px 8px rgba(0 0 0 / 0.12);
    display: flex;
    gap: 16px;
    padding: 24px;
  }
`;
